import { useCallback } from 'react';
import { useKeyRecorder } from '../key-recorder/use-key-recorder';
import { logWarn } from '../../monitoring/log';

export const useNarrativeOverwriteSensor = (agencyEventId: number) => {
    const { keyRecorder } = useKeyRecorder();

    const narrativeOverwriteSensor = useCallback(
        ({ prevContent, newContent }: { prevContent: string; newContent: string }) => {
            if (
                prevContent.length !== 0 &&
                prevContent.length === newContent.length &&
                prevContent.localeCompare(newContent) === 0 &&
                prevContent !== '\n' &&
                keyRecorder?.recordedEvents !== undefined
            ) {
                logWarn('Narrative input content overwrite detected', {
                    agencyEventId,
                    keyEvents: keyRecorder.recordedEvents,
                });
            }
        },
        [agencyEventId, keyRecorder?.recordedEvents]
    );

    return { narrativeOverwriteSensor };
};
